import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Card} from "@radix-ui/themes";
import registerService from "../service/registerService";

export default function ConfirmSignupView() {
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email || "";
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);
    const [message, setMessage] = useState("");

    const confirm = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            await registerService.confirmUser(email, code);
            setMessage("Conta confirmada com sucesso!");
            navigate("/login");
        } catch (error) {
            setMessage(`Erro ao confirmar registro: ${error}`);
        } finally {
            setLoading(false);
        }
    };

    const resendCode = async () => {
        setResending(true);
        setMessage("");

        try {
            await registerService.resendConfirmationCode(email);
            setMessage("Código reenviado com sucesso!");
        } catch (error) {
            setMessage(`Erro ao reenviar código: ${error}`);
        } finally {
            setResending(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <Card className="w-96 p-8 bg-white shadow-lg rounded-lg">
                <h1 className="text-2xl font-semibold text-[#2294ae] text-center mb-6">Confirme seu Registro</h1>
                
                {message && (
                    <p className={`text-center mb-4 ${message.includes("sucesso") ? "text-green-500" : "text-red-500"}`}>{message}</p>
                )}

                <p className="text-center mb-4 text-gray-600">Um código foi enviado para <strong>{email}</strong>. Digite abaixo para confirmar sua conta.</p>
                
                <form onSubmit={confirm}>
                    <input type="text" value={code} onChange={(e) => setCode(e.target.value)} className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Código de Confirmação" required />
                    
                    <button type="submit" className={`w-full mt-2 py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2294ae]`} disabled={loading}>
                        {loading ? "Confirmando..." : "Confirmar"}
                    </button>
                </form>

                <button onClick={resendCode} className="w-full py-2 mt-4 bg-gray-500 text-white font-bold rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" disabled={resending}>
                    {resending ? "Reenviando..." : "Reenviar Código"}
                </button>
            </Card>
        </div>
    );
}